<template>
	<div class="pindex">
		<section class="container">
			<router-view></router-view>
		</section>
	</div>
</template>
<script>
	
	import store from '../vuex/store';
	import {
		mapGetters
	} from 'vuex';
	export default {
		store,
		computed: {
			...mapGetters([
				'ind'
			])
		},
	}
</script>
<style lang="scss">
	@import "../styles/core/reset.scss";
	.pindex {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		.header {
			position: absolute;
			width: 100%;
			height: .4rem;
			background: rgba(0, 0, 0, 0.9);
			top: 0;
			left: 0;
			color: #fff;
			font-size: .16rem;
			z-index: 999;
			ul {
				@include flexbox;
				float: right;
				li {
					padding-right: .15rem;
					line-height: .4rem;
				}
			}
			h4{
				text-align: right;
				line-height: .4rem;
				font-weight: normal;
				padding-right: .15rem;
				span{
					&:first-child{
						padding-right: .1rem;
					}
				}
			}
		}
		.container {
			width: 100%;
			height: 100%;
			background: #F4F5F8;
			overflow: hidden;
			.myScroller {
				width: 100%;
				height: 100%;
			}
		}
		.footer{
			width: 100%;
			height: .56rem;
			background: rgba(0,0,0,0.9);
			position: absolute;
			left: 0;
			bottom: 0;
			font-size: .18rem;
			ul{
				@include flexbox;
				height: .56rem;
				li{
					@include flex;
					height: .56rem;
					text-align: center;
					box-sizing: border-box;
					line-height: .56rem;
					color: #fff;
					z-index: 999;
					&:last-child{
						position: relative;
						.dropdowns{
							position: absolute;
							right: 0;
							bottom: .68rem;
							width: 100%;
							background: #FAFAFA;
							font-size: .12rem;
							border: 1px solid #DADADA;
							box-sizing: border-box;
							margin: 0 .06rem;
							ul{
								width: 100%;
								height: 100%;
								@include flexbox;
								@include flex-direction(column);
								li{
									width: 100%;
									height: .44rem;
									color: #555;
									line-height: .44rem;
									&:not(:first-child){
										border-top: 1px solid #DEDEDE;
									}
									&:last-child{
										position: relative;
										img{
											position: absolute;
											bottom: -.12rem;
											left: 50%;
											transform: translate(-50%,0);
										}
									}
								}
							}
						}
					}
					p{
						width: 100%;
						height: 100%;
						border-top: 3px solid #000;
						&.active{
							border-top: 3px solid #467DE5;
						}
					}
					
				}
			}
		}
		.alertMark {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.7);
			z-index: 999;
			.alert-content {
				width: 3.25rem;
				height: 4.57rem;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				background: #fff;
				border-radius: .05rem;
				@include flexbox;
				@include flex-direction(column);
				overflow: hidden;
				h4 {
					font-size: .17rem;
					border-bottom: 1px solid #eee;
					height: .5rem;
					text-align: center;
					line-height: .5rem;
					position: relative;
					img {
						position: absolute;
						top: 50%;
						right: .15rem;
						width: .15rem;
						height: .15rem;
						transform: translate(0, -50%);
					}
				}
				ul {
					font-size: .14rem;
					width: 100%;
					height: .33rem;
					@include flexbox;
					li {
						@include flex;
						width: 100%;
						height: 100%;
						@include flexbox;
						align-items: center;
						justify-content: center;
						&:last-child {
							border-left: 1px solid #eee;
						}
						&.active {
							border-bottom: 3px solid #467DE5;
							color: #467de5;
						}
					}
				}
				.el-form {
					@include flex;
					width: 100%;
					font-size: .14rem;
					position: relative;
					.el-form-item {
						padding-top: .15rem;
						margin: 0;
						.el-form-item__label {
							float: left;
							font-size: .12rem;
							padding-left: .15rem;
							color: #555;
						}
						.el-form-item__content {
							clear: both;
							.el-input {
								background: #F4F5F8;
								border: none;
								input {
									border: none;
									background: #F4F5F8;
									font-size: .14rem;
									height: .44rem;
								}
								input::-webkit-input-placeholder {
									color: #999;
								}
							}
							.el-form-item__error {
								color: #ff4949;
								font-size: 0.12rem;
								line-height: 40px;
								position: absolute;
								top: 0;
								right: 8px;
								padding: 0 8px;
								left: auto;
							}
						}
						&.regCodeFrom {
							.el-form-item__content {
								position: relative;
								.codebutton {
									position: absolute;
									top: 50%;
									right: .1rem;
									transform: translate(0, -50%);
									color: #467DE5 !important;
									font-size: .14rem;
									border:none;
									background: #F4F5F8;
								}
							}
							.el-form-item__error{
								right: .92rem;
							}
						}
					}
					.forgotPassword {
						text-align: right;
						display: block;
						color: #555;
						padding: .1rem .15rem 0 0;
					}
					.myfrom-buttons {
						position: absolute;
						bottom: 0;
						left: 0;
						width: 100%;
						height: .5rem;
						border: none;
						border-radius: 0;
						background: #467DE5;
						color: #fff;
						font-size: .17rem;
						text-align: center;
						line-height: .5rem;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// pindex.vue?8b32a106